import IPricingOption from "../interfaces/IPricingOption";
import { IPricingOptionsObject } from "./menuItemController";

/**Creates the price options object */
export function createPriceOption(optionName: string, optionPrice: string | number,
    quantity?: string | number, discount?: string | number, integrationObjectId?: string): IPricingOption {
    const newQua = valueParser(quantity) || 1;
    const newDisc = valueParser(discount) || 0;
    const price = valueParser(optionPrice);
    const integrationId = integrationObjectId ? {option_integration_object_id: integrationObjectId} : {};
    if (price === null) { throw Error(`Failed to parse price`); }
    return {
        option_name: optionName,
        option_price: Math.round(price * 100),
        option_bulk_qty: newQua,
        option_discount: newDisc,
        ...integrationId
    };
};
/** checks if the values a string or a number turns into number if needed*/
const valueParser = (parsedValue?: string | number): number | null => {
    if (parsedValue !== null) {
        if (typeof parsedValue === "string") {
            return parseFloat(parsedValue);
        } else if (typeof parsedValue === "number") {
            return parsedValue;
        }
    }
    return null;
};
export type PriceOptionsKey = "po" | "poe";
/**Turns pricing option array into an object for the API */
export const createPriceOptionsObject = (priceObject: IPricingOptionsObject | IPricingOption[], priceKey: PriceOptionsKey, priceOptionKey: string) => {
    const priceOps: any = {};
    let error = false;
    let errMsg = "";
    const objectKeys = Object.keys(priceObject);
    const length = objectKeys.length;
    if (length > 0) {
        for (let i = 0; i < length; i++) {
            const key = priceKey + (i + 1).toString();
            const objKey = objectKeys[i];
            //@ts-ignore
            const obj = priceObject[objKey];
            /**Pricing ops extra check if its a string and the length of the string is 0 it will fail */
            if (obj.option_price === undefined || obj.option_price === null || (typeof obj.option_price === "string" && obj.option_price.length === 0)) {
                error = true;
                errMsg = "Option price not found";
                break;
            }
            /**if names empty we'll just ignore it */
            priceOps[key] = createPriceOption(obj.option_name, obj[priceOptionKey], obj.option_bulk_qty, obj.option_discount, obj.option_integration_object_id);
        }
    }

    return { priceOps, error, errMsg };
    // for
};

/**Turns the pricing options object into an array */
export const pricingOptionsIntoArray = (pricingObject: { [key: string]: IPricingOption; }) => {
    const keys = Object.keys(pricingObject);
    const array = [];
    for (let i = 0; i < keys.length; i++) {
        array.push(pricingObject[keys[i]]);
    }
    return {
        priceOpsArray: array,
        length: keys.length
    };
};

export function penceIntoPounds(pricingOptions: IPricingOption) {
    const penceDivider = 100;
    if (pricingOptions !== undefined) {
        const price = pricingOptions.option_price;
        if (typeof price === "string") {
            return (parseInt(price) / penceDivider).toFixed(2);
        } else {
            return (price / penceDivider).toFixed(2);
        }
    }
}

// export const createPriceOptionsObject = (productPrice: number) => {
//     const arrayOfDiscounts = [{ optionName: "single" },
//     { optionName: " ", quantity: 3, discount: 20 },
//     { optionName: " ", quantity: 5, discount: 25 },
//     { optionName: " ", quantity: 10, discount: 30 },
//         // { optionName: " ", quantity: 25, discount: 50 }
//     ];
//     const priceOps: any = {};
//     for (let i = 0; i < arrayOfDiscounts.length; i++) {
//         const key = 'po' + (i + 1).toString();
//         const obj = arrayOfDiscounts[i];
//         priceOps[key] = createPriceOption(obj.optionName, productPrice, obj.quantity, obj.discount);
//     }
//     return priceOps;
//     // for
// };